import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import {useState} from "react";
import RaikoBaseContainer from "../../raikoComponents/raikoBaseContainer/RaikoBaseContainer";
import {css} from "@emotion/css";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";

const AddNewGallery = () => {
    const [title, setTitle] = useState("")
    return (
        <RaikoGridOneColumn className={css`padding: 1rem`}>
            <RaikoSimpleInputOutlined
                labelText={"عنوان گالری"}
                setValue={setTitle}
                value={title}/>
            <ButtonDivisionSection>
                <ButtonPrimaryRaiko label={"بروزرسانی"}/>
            </ButtonDivisionSection>
        </RaikoGridOneColumn>
    )
}
export default AddNewGallery;